function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m32 0c-17.677 0-32 14.323-32 32s14.323 32 32 32 32-14.323 32-32-14.323-32-32-32zm0 57.806c-14.258 0-25.806-11.548-25.806-25.806s11.548-25.806 25.806-25.806 25.806 11.548 25.806 25.806-11.548 25.806-25.806 25.806zm7.9742-13.471-10.955-7.9613c-0.4-0.29678-0.63226-0.76129-0.63226-1.2516v-21.187c0-0.85161 0.69677-1.5484 1.5484-1.5484h4.129c0.85161 0 1.5484 0.69677 1.5484 1.5484v18.284l8.6194 6.271c0.69677 0.50322 0.83871 1.471 0.33548 2.1677l-2.4258 3.3419c-0.50322 0.68387-1.471 0.83871-2.1677 0.33548z",
    fill: "currentColor",
    style: {
      strokeWidth: 0.12903
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.773ec141.svg";
export { ForwardRef as ReactComponent };